module.exports = __webpack_public_path__ + "img/CATEGORY ICON-16.2920f1f5.png";